import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import {
  HeadingDescSmall,
  HeadingDescVsmall,
  HeadingWithSpaceLarge
} from '../../../../Components/Headings';
import './comment.css';

const comments = [
  {
    articleName: 'Make the Most of Your Safer-at-Home Summer',
    comment:
      'Prof. Nadia Khurshid Ahmed is a Gynecologist and Obstetrician. She has a..',
    link: '#1'
  },
  {
    articleName: 'Make the Most of Your Safer-at-Home Summer',
    comment:
      'Prof. Nadia Khurshid Ahmed is a Gynecologist and Obstetrician. She has a..',
    link: '#2'
  },
  {
    articleName: 'Make the Most of Your Safer-at-Home Summer',
    comment:
      'Prof. Nadia Khurshid Ahmed is a Gynecologist and Obstetrician. She has a..',
    link: '#3'
  },
  {
    articleName: 'Make the Most of Your Safer-at-Home Summer',
    comment:
      'Prof. Nadia Khurshid Ahmed is a Gynecologist and Obstetrician. She has a..',
    link: '#4'
  },
  {
    articleName: 'Make the Most of Your Safer-at-Home Summer',
    comment:
      'Prof. Nadia Khurshid Ahmed is a Gynecologist and Obstetrician. She has a..',
    link: '#5'
  },
  {
    articleName: 'Make the Most of Your Safer-at-Home Summer',
    comment:
      'Prof. Nadia Khurshid Ahmed is a Gynecologist and Obstetrician. She has a..',
    link: '#6'
  }
];

function Comments() {
  return (
    <section className="commmentSec">
      <HeadingWithSpaceLarge text="YOUR COMMENTS" />
      <div className="commentsContainer">
        <div className="firstRow">
          <Row>
            <Col className="col-7" md={5}>
              <div className="customColounm">
                <HeadingDescSmall text="Article" />
              </div>
            </Col>
            <Col md={6}>
              <div className="customColounm ms-2 ms-lg-0">
                <HeadingDescSmall text="Your comment" />
              </div>
            </Col>
          </Row>
        </div>
        <div className="secondRow">
          {comments.map((singleComment) => {
            const { articleName, comment, link } = singleComment;
            return (
              <Row key={link}>
                <Col className="col-5" md={5}>
                  <div className="customColounm">
                    <HeadingDescVsmall text={articleName} />
                  </div>
                </Col>
                <Col className="col-7" md={7}>
                  <div className="customColounm">
                    <h6 className="headingDescVsmall">
                      {comment}
                      <Link to={link}>show more</Link>
                    </h6>
                  </div>
                </Col>
                {/* <Col className="col-3" md={3} /> */}
              </Row>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Comments;
